<template>
	<div id="manageProperty" class="viewport">	
			<div class="columns">
				<div class="column">
					<h1>Property {{property.abk}}</h1>
				</div>
				<div class="column alignRight">
					<button class="button buttonSave is-pulled-right" v-on:click="propertySave">Speichern</button>
					<router-link tag="button" class="button is-pulled-right" :to="{ name: 'ManageProperties' }">Zurück</router-link>
				</div>
			</div>
		<div class="propertyKeyfacts">
			<div class="columns">
				<div class="column">
					<div class="borderround">
						<h2>Key Facts</h2>
						<div class="property_abk"><input v-model="property.abk" maxlength="3"><label>ABK</label></div>
						<div class="property_domain"><input v-model="property.domain"><label>Domain</label></div>
						<div class="property_active"><input v-model="property.active_property" type="checkbox" :checked="property.active_property == 1"> AKTIV</div>
						
							
						
					</div>
				</div>
				<div class="column">
					<div class="borderround">					
						<h2>E-Mail-Settings</h2>
						<div class="property_mail_user"><input v-model="property.mailconfig.user"><label>User</label></div>
						<div class="property_mail_passwrd"><input v-model="property.mailconfig.passwrd"><label>Passwort</label></div>
						<div class="property_mail_host"><input v-model="property.mailconfig.host"><label>Host</label></div>
						
					</div>
				</div>
			</div>
		</div>			
	</div>
</template>
<script>
import sweetalert from 'sweetalert';	
	
export default {
	name: "ManageProperty",	
	props: ['propid'],
	data() {
	    return {
	      		property: { 
		      		id: 'new', 
		      		abk: "", 
		      		domain:"",
		      		active_property: 0, 
		      		mailconfig: {
			      		user: '',//'post@austauschmotoren.shop',//'anfrage@austauschmotoren.shop'
				  		passwrd: '',//'Lc8EwngPqPPZU8wc',
					    host: ''//'w0171ee7.kasserver.com',
		      		} 
		      	},	      		
	      		buttonText: 'Speichern'      		
			  }
	},
	watch: {
		'property.abk' : {
					handler: function(val, oldVal){ console.log('user changed from '+oldVal+' to ' + val); $('.buttonSave','#manageProperty').text(this.buttonText); }
				},
		'property.domain' : {
					handler: function(val, oldVal){ console.log('user changed'); $('.buttonSave','#manageProperty').text(this.buttonText); }
				},
		'property.active_property' : {
					handler: function(val, oldVal){ console.log('user changed'); $('.buttonSave','#manageProperty').text(this.buttonText); }
				},
		'property.mailconfig.user' : {
					handler: function(val, oldVal){ console.log('user changed'); $('.buttonSave','#manageProperty').text(this.buttonText); }
				},
		'property.mailconfig.passwrd' : {
					handler: function(val, oldVal){ console.log('user changed'); $('.buttonSave','#manageProperty').text(this.buttonText); }
				},
		'property.mailconfig.host' : {
					handler: function(val, oldVal){ console.log('user changed'); $('.buttonSave','#manageProperty').text(this.buttonText); }
				},
		deep: true
	},
	sockets: {
		getPropertyByID(r){
			console.log(r);
			this.property.id = r.id
			this.property.abk = r.abk
			this.property.domain = r.domain
			this.property.active_property = r.active_property
			if( r.mailconfig ) this.property.mailconfig = JSON.parse(r.mailconfig)
		},		
		propertySaved(r){			
			var $this = this;			
			if(r.success == true )
			setTimeout( function(){ $('.buttonSave','#manageProperty').html('<i class="fa fa-check"></i>') },1000);
			else {
				setTimeout( function(){ $('.buttonSave','#manageProperty').html('<i class="fa fa-check"></i>') },1000);
				console.log(r.message);		
			    sweetalert({ 
			    	title: $this.property.abk + " gibt es schon in der Datenbank. ",
					text: "Die Abkürzung muss unique sein!", 
					icon: "warning", 
					timer: 3000,
					buttons: false,
					dangerMode: true

			    });
					
			}
			
			
		},
	},
	methods: {
		propertySave(e) {
			console.log(this.property);
			if( this.property.abk != "" && this.property.domain != "") {
				$(e.currentTarget).html('<i class="fa fa-spinner fa-pulse"></i>');
				this.$socket.emit('propertySave', { update: { property: this.property }, quiet: 0 } );	
			}					
		},		
	},
	mounted: function(){
		console.log('id: ' + this.propid);		
		if( this.propid == "new" )
		this.property.id = 'new'
		else		
		this.$socket.emit('getPropertyByID', { propertyid: this.propid });
	},
	created: function(){
	},	
	

	
}	
</script>